// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable react/no-unknown-property */
/** @jsx jsx */
// eslint-disable-next-line no-unused-vars
import React from 'react'
import { MdPhoneInTalk } from 'react-icons/md'
import { TiDocumentText } from 'react-icons/ti'
import { jsx } from 'theme-ui'
import { Box, NavLink, Flex } from '../elements'

const segmentStyle = {
  width: '50%',
  height: 50,
  fontSize: [2, 2, 3],
}

export const LeftBG = () => (
  <svg width="857" height="50" viewBox="0 0 857 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0.5H856.5L832.5 49.5H0V0.5Z" fill="#C4C4C4" />
  </svg>
)
export const RightBG = () => (
  <svg width="567" height="49" viewBox="0 0 567 49" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M567 49H0L24 0H567V49Z" fill="#C4C4C4" />
  </svg>
)

export const Divider = ({ ...props }) => (
  <svg
    width={100}
    height={100}
    preserveAspectRatio="none"
    viewBox="0 0 100 100"
    {...props}
    sx={{
      bg: 'white',
      display: ['none', 'none', 'block'],
      '.left': {
        fill: 'primary',
      },
    }}
  >
    <path className="left" d="M-.5 100V-.5H89L-.5 100z" />
    <path d="M100.5-.5V101H11L100.5-.5z" fill="black" />
  </svg>
)
export const SegmentWrapper = ({ ...props }) => (
  <Flex
    {...props}
    sx={{
      mr: 'auto',
      height: '100%',
      px: [1, 2, 3, 4],

      'a, a > p': {
        fontSize: [14, 14, 16, 18],
        fontWeight: 700,
        fontFamily: '"Barlow Condensed",Barlow Condensed,  sans-serif',
        textTransform: 'uppercase',
        color: 'white',
        lineHeight: '1.2',
        whiteSpace: 'nowrap',
        p: { my: 0 },
      },
    }}
  />
)
export const Left = ({ ...props }) => (
  <Box
    bg="primary"
    color="white"
    {...props}
    sx={{
      ...segmentStyle,
      width: ['50%', '50%', '75%'],
    }}
  >
    <SegmentWrapper
      sx={{
        alignItems: 'center',
        ml: 'auto',
        justifyContent: ['center', 'center', 'flex-end'],
        height: '100%',
      }}
    >
      <a
        href="tel:410-752-7663"
        sx={{
          display: 'flex',
          ':hover': { color: 'white' },
          alignItems: 'center',
        }}
      >
        <MdPhoneInTalk sx={{ mr: [1, 2], fontSize: [3] }} />
        <p>PHONE: 410-752-7663</p>
      </a>
    </SegmentWrapper>
  </Box>
)

export const Right = ({ ...props }) => (
  <Box
    bg="black"
    color="white"
    {...props}
    sx={{
      ...segmentStyle,
      width: ['50%', '50%', '25%'],
    }}
  >
    <SegmentWrapper
      sx={{
        alignItems: 'center',
        display: 'flex',
        mr: 'auto',
        justifyContent: ['center', 'center', 'flex-start'],
        height: '100%',
        pl: [2, 3, 4],
      }}
    >
      <NavLink
        to="/contact"
        sx={{
          alignItems: 'center',
          display: 'flex',
          ':hover': { color: 'white' },
        }}
      >
        <TiDocumentText sx={{ ml: '1', mr: [1, 2], fontSize: [3] }} />
        <p>REQUEST A FREE ESTIMATE</p>
      </NavLink>
    </SegmentWrapper>
  </Box>
)
export const TopNav = () => {
  return (
    <Box
      sx={{
        top: 0,
        left: 0,
        display: 'flex',
        width: '100%',
      }}
    >
      <Left />
      <Box position="relative" width={0}>
        <Divider height={50} width={40} sx={{ left: '-20px' }} />
      </Box>
      <Right />
    </Box>
  )
}

export default TopNav
